// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__sqAVj","approved":"Status_approved__3EHh7","rejected":"Status_rejected__trD0-","expired":"Status_expired__1W7cv","label":"Status_label__1QBav"};